/* globals jQuery, DLSPH_ALUMNI */
import carouselSetup from './theme/carousel';
import './theme/css-animate-transition';
import makeTweets from './theme/twitter';

jQuery( $ => {
	const $window = $( window );
	const $document = $( document );
	const $body = $( 'body' );

	// =========================
	// ! Supports Flagging
	// =========================

	$body.removeClass( 'no-js' ).addClass( 'js' );

	$document
		.on( 'touchstart', function() {
			$body.removeClass( 'notouch' ).addClass( 'touch' );
		} )
		.on( 'mousedown', function() {
			$body.addClass( 'using-mouse' );
		} )
		.on( 'keydown', function() {
			$body.removeClass( 'using-mouse' );
		} );

	// =========================
	// ! Form Stuff
	// =========================

	$( '.js-autosubmit' ).change( function() {
		$( this ).parents( 'form' ).submit();
	} );

	// =========================
	// ! Accordion
	// =========================

	// Upgrade DLSPH accordion headers to accordions
	$( '.accordion-header' ).each( function() {
		const stop = [ 'hr' ];
		let level = parseInt( this.tagName.toLowerCase().replace( 'h', '' ) );

		while ( level > 1 ) {
			stop.push( `h${ level }` );
			level--;
		}

		$( this ).nextUntil( stop.join( ',' ) + ',.cear' )
			.wrapAll( '<div class="dlsph-accordion__content"><div class="dlsph-accordion__content__inner"></div></div>' );

		$( this )
			.removeClass( 'accordion-header' )
			.addClass( 'dlsph-accordion__header' )
			.wrapInner( '<span class="dlsph-accordion__title"></span>' )
			.prepend( '<button class="dlsph-accordion__toggle"></button>' );

		$( [ this, this.nextElementSibling ] ).wrapAll( '<div class="dlsph-accordion"></div>' );
	} );

	$( '.dlsph-accordion' ).each( function() {
		const $self = $( this );
		const $header = $self.find( '.dlsph-accordion__header' );
		const $content = $self.find( '.dlsph-accordion__content' );

		$header.click( function() {
			$self.toggleClass( 'is-open' );
			if ( $self.hasClass( 'is-open' ) ) {
				$content.addClass( 'open' ).stop().hide().animate( { height: 'toggle' }, () => $content.attr( 'style', '' ) );
				$self.siblings().each( function() {
					if ( $( this ).hasClass( 'is-open' ) ) {
						$( this ).removeClass( 'is-open' );
						$( this ).find( '.dlsph-accordion__content' ).stop().show().animate( { height: 'toggle' }, function() {
							$( this ).attr( 'style', '' ).removeClass( 'open' );
						} );
					}
				} );
			} else {
				$content.stop().show().animate( { height: 'toggle' }, function() {
					$( this ).attr( 'style', '' ).removeClass( 'open' );
				} );
			}
		} );
	} );

	$( window ).on( 'hashchange', function() {
		const target = window.location.hash;

		if ( target.length > 1 && $( target ).hasClass( 'dlsph-accordion' ) ) {
			$( target ).find( '.dlsph-accordion__header' ).trigger( 'click' );
		}
	} ).trigger( 'hashchange' );

	$( '.dlsph-accordion.auto-open .dlsph-accordion__header' ).click();

	// =========================
	// ! Carousels
	// =========================

	$( '.vertical-carousel' ).each( carouselSetup );

	$( '.horizontal-carousel' ).each( function() {
		$( this ).find( '.js-slides-wrap' ).slick( {
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 3,
			prevArrow: $( this ).find( '.js-prev' ),
			nextArrow: $( this ).find( '.js-next' ),
			responsive: [
				{
					breakpoint: 900,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					},
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		} );
	} );

	// =========================
	// ! Nav Toggle (recycled from lambay)
	// =========================

	$( '.flyout-toggle' ).click( function() {
		$( '.header' ).toggleClass( 'show-flyout' );
	} );

	// =========================
	// ! Topbar Toggle
	// =========================

	$( '.topbar-toggle' ).click( function() {
		$( '.topbar__menu' ).toggleClass( 'open' );
		$( '.topbar' ).toggleClass( 'is-open' );
	} );
	// =========================
	// ! Intersection Observers
	// =========================

	if ( typeof IntersectionObserver !== 'undefined' ) {
		const headerHeight = $( '.header' ).outerHeight() || 0;

		// =========================
		// ! - Sticky Header observer
		// =========================

		const $header = $( '.header' );
		const $topbar = $( '.topbar' );

		const observer = new IntersectionObserver( entries => {
			$header.toggleClass( 'is-sticky', ! entries[ 0 ].isIntersecting );
		} );

		observer.observe( $topbar[ 0 ] );

		// =========================
		// ! - Page Nav Scroll Spy - Recycled from lambay
		// =========================

		const $links = $( '.page-nav__link' );
		const $headings = $( '.page-layout' ).find( '[id]' );
		const headingObserver = new IntersectionObserver( entries => {
			entries.forEach( entry => {
				$( entry.target ).toggleClass( 'in-view', entry.isIntersecting );
			} );

			// Find the "current" heading in view
			let $currentHeading = $headings.filter( '.in-view' );

			// In case of multiple, use the first one who's
			// top isn't outside the viewport
			if ( $currentHeading.length > 1 ) {
				const scrollTop = $window.scrollTop();
				$currentHeading = $currentHeading.filter( function() {
					return $( this ).offset().top >= scrollTop - 100;
				} ).first();
			}

			$links.removeClass( 'is-current' ).filter( `[href="#${ $currentHeading.attr( 'id' ) }"]` ).addClass( 'is-current' );
		}, {
			rootMargin: `-${ headerHeight }px 0px 0px`,
		} );

		$( '.page-layout' ).find( 'h2[id], div[id], section[id]' ).each( function() {
			headingObserver.observe( this );
		} );
	}

	// =========================
	// ! Twitter Feed Handling
	// =========================

	$( '.js-twitter-feed' ).each( function() {
		const $wrapper = $( this );
		const $feed = $wrapper.find( '.js-tweets' );
		const template = $wrapper.find( '.js-tweet-template' ).html();

		$feed.each( function() {
			const account = $( this ).data( 'account' );
			$.get( DLSPH_ALUMNI.rest_twitter_url, { screen_name: account }, tweets => {
				$( this ).append( makeTweets( tweets, template ) );
			}, 'json' );
		} );
	} );
} );
